import { find, isNil, propEq } from 'ramda'
import { countries } from '@tokeet/tv3-platform'

export function getCountryName(id: string) {
  let country = find(propEq('id', id), countries)
  return isNil(country) ? null : country.name
}
